import axios from "axios";

const validaCPF = (strCPF) => {
    let Soma;
    let Resto;
    Soma = 0;
    if (strCPF === "00000000000") return false;
    let i = 0;
    for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if ((Resto === 10) || (Resto === 11)) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
}

const zApiUrl = 'https://api.z-api.io/instances/394207B128E900BFC7029A907D5E67B3/token/E1AF9F3796B5131FD8947C94'
const zApiConfig = {
    headers: {
        "Client-Token": "Fa621472ba827427785762331807e0e22S"
    }
}

export async function sendWhatsappMessage(phone, message) {
    const instanceAPI = `${zApiUrl}/send-text`;
    console.log("nodeEnv", phone, "process.env.NODE_ENV", process.env.NODE_ENV)

    const data = {
        "phone": process.env.NODE_ENV == "production" ? phone : '5516992028774',
        // "phone": phone,
        "message": process.env.NODE_ENV == "production" ? message : `${message} - TESTE UNILABS`
    }

    try {
        return await axios.post(instanceAPI, data, zApiConfig)
    } catch (error) {
        console.log(error)
    }
}

export async function sendWhatsappButtons(phone, message, buttons) {
    const instanceAPI = `${zApiUrl}/send-button-list`;
    console.log("nodeEnv", phone)

    const data = {
        "phone": process.env.NODE_ENV == "production" ? phone : '5516992028774',
        // "phone": phone,
        "message": process.env.NODE_ENV == "production" ? message : `${message} - TESTE UNILABS`,
        "buttonList": { buttons }
    }

    try {
        return await axios.post(instanceAPI, data, zApiConfig)
    } catch (error) {
        console.log(error)
    }
}

export async function wpOnMessageReceived(phone, message) {
    const host = "https://us-central1-globalbrain-ba498.cloudfunctions.net/whatsapp/on-message-received";
    // const host = "http://localhost:5001/globalbrain-ba498/us-central1/whatsapp/on-message-received";
    const data = {
        "phone": phone,
        "text": {
            "message": message
        }
    }
    console.log(host)
    console.log(data)
    try {
        await axios.post(host, data)
    } catch (error) {
        console.log(error)
    }
}

export function onlyNumbers(value) {
    return value.replace(/\D/g, '');
}

export function removeAcentos(value) {
    // return value.normalize('NFKD').replace(/[^\w]/g, '')
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

export function toCurrency(value) {
    return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
}

export {
    validaCPF
}

export const corRaca = () => {
    return [
        { descricao: 'Branco', id: 'Branco' },
        { descricao: 'Negro', id: 'Negro' },
        { descricao: 'Pardo', id: 'Pardo' },
        { descricao: 'Amarelo', id: 'Amarelo' }
    ]
}

export async function getCepFn(cep) {
    const resCep = await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
    console.log(resCep)
    return resCep.data
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const age = (birthdate) => {
    var dob = new Date(birthdate);
    //calculate month difference from current date in time  
    var month_diff = Date.now() - dob.getTime();

    //convert the calculated difference in date format  
    var age_dt = new Date(month_diff);

    //extract year from date      
    var year = age_dt.getUTCFullYear();

    //now calculate the age of the user  
    var age = Math.abs(year - 1970);
    return age
}

export const getApiToken = async () => {
    const data = {
        "username": "unilabs",
        "password": "unilabs123"
    }
    const result = await axios.post(`${apiEndpoint()}/auth/login`, data)
    if (result) {
        localStorage.setItem("apiToken", result.data.access_token)
    }
}

export const apiEndpoint = () => {
    // return "http://localhost:3001/api"
    return "https://api-globalbrain.vercel.app/api"
}

export const getStorageToken = async () => {
    let token = localStorage.getItem("apiToken")
    if (!token) {
        await getApiToken()
        token = localStorage.getItem("apiToken")
    }
    return token
}

// export function isMobile() {
//     // if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
//     //     return true
//     // } else {
//     //     return false
//     // }
//     console.log("navigator.userAgent", navigator.userAgent)

//     if (navigator.userAgent.match(/Android/i)
//         || navigator.userAgent.match(/webOS/i)
//         || navigator.userAgent.match(/iPhone/i)
//         || navigator.userAgent.match(/iPad/i)
//         || navigator.userAgent.match(/iPod/i)
//         || navigator.userAgent.match(/BlackBerry/i)
//         || navigator.userAgent.match(/Windows Phone/i)
//     ) {
//         return true
//     } else {
//         return false
//     }
// }
